import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import ContactForm from "@/pages/about/components/ContactForm";

const values = [
  {
    icon: "ri-lightbulb-line",
    title: "创立初衷",
    desc: "我们相信好故事值得被更多人看见。色色影院希望用清晰的信息与便捷的检索，降低发现好内容的门槛。",
  },
  {
    icon: "ri-stack-line",
    title: "内容范围",
    desc: "覆盖电影与电视剧两大板块，包含动作、科幻、悬疑、都市、古装等二十余种类型，满足多样化的观影偏好。",
  },
  {
    icon: "ri-heart-3-line",
    title: "服务宗旨",
    desc: "以用户为中心，持续优化筛选、搜索与推荐体验，让每一次访问都能快速找到想看的内容。",
  },
];

const guides = [
  "使用顶部搜索框输入影视名称、导演或演员，即可快速定位作品。",
  "在分类页通过类型、地区、年份组合筛选，并按上映时间、热度或评分排序。",
  "点击任意影视卡片进入详情页，可查看资料、剧情介绍与相关推荐。",
  "点击“收藏”按钮即可保存喜欢的作品，收藏状态会保存在你的浏览器本地。",
];

const contacts = [
  { icon: "ri-mail-line", label: "反馈邮箱", value: "support@sesemovie.demo" },
  { icon: "ri-time-line", label: "服务时间", value: "工作日 09:00 - 18:00" },
  { icon: "ri-map-pin-line", label: "办公地址", value: "示例市示例区影视大道 88 号" },
];

export default function About() {
  useDocumentTitle(
    "关于我们 - 色色影院",
    "了解色色影院的创立初衷、内容范围与服务宗旨，并通过在线留言与我们取得联系。",
  );

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <section className="bg-primary-900">
          <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
            <nav className="mb-4 flex flex-wrap items-center gap-1.5 text-xs text-background-100/70">
              <Link to="/" className="transition-colors hover:text-accent-400">
                首页
              </Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-background-50">关于我们</span>
            </nav>
            <h1 className="font-heading text-3xl font-bold text-background-50 md:text-4xl">
              关于色色影院
            </h1>
            <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-100/80 md:text-base">
              一个面向广大影视爱好者的内容门户，专注于提供最新电影与电视剧的浏览、检索与信息服务。
            </p>
          </div>
        </section>

        <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6">
            {values.map((item) => (
              <div
                key={item.title}
                className="rounded-lg border border-background-200 bg-background-50 p-6"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                  <i className={`${item.icon} text-2xl`}></i>
                </span>
                <h2 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                  {item.title}
                </h2>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="bg-background-100">
          <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
            <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
              <div>
                <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                  联系我们
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                  无论是内容报错、功能建议还是合作咨询，都欢迎与我们取得联系，我们会认真对待每一条反馈。
                </p>

                <ul className="mt-6 space-y-4">
                  {contacts.map((item) => (
                    <li
                      key={item.label}
                      className="flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4"
                    >
                      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                        <i className={`${item.icon} text-xl`}></i>
                      </span>
                      <div>
                        <p className="text-xs text-foreground-500">{item.label}</p>
                        <p className="mt-0.5 text-sm font-medium text-foreground-900">
                          {item.value}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>

                <div className="mt-6 rounded-lg bg-secondary-100 p-5">
                  <h3 className="flex items-center gap-2 text-sm font-semibold text-secondary-900">
                    <i className="ri-error-warning-line text-lg"></i>
                    版权与声明
                  </h3>
                  <p className="mt-2 text-xs leading-relaxed text-secondary-800">
                    本站为演示站点，页面中出现的所有影视名称、导演、主演、评分及联系方式均为虚构示例，不涉及任何真实作品、机构或个人。本站不提供也不涉及任何播放、下载或会员服务。
                  </p>
                </div>
              </div>

              <div>
                <ContactForm />
              </div>
            </div>
          </div>
        </section>

        <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            使用说明
          </h2>
          <p className="mt-3 text-sm text-foreground-600">几步就能找到你想看的影视内容：</p>
          <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
            {guides.map((guide, index) => (
              <div
                key={guide}
                className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent-500 text-sm font-bold text-background-50">
                  {index + 1}
                </span>
                <p className="text-sm leading-relaxed text-foreground-700">{guide}</p>
              </div>
            ))}
          </div>

          <div className="mt-10 flex flex-wrap gap-3">
            <Link
              to="/category"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
            >
              <i className="ri-compass-3-line text-lg"></i>
              开始浏览影视
            </Link>
            <Link
              to="/"
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              <i className="ri-home-4-line text-lg"></i>
              返回首页
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}